import { render, staticRenderFns } from "./DetailRow.vue?vue&type=template&id=1429501d&scoped=true&"
import script from "./DetailRow.vue?vue&type=script&lang=js&"
export * from "./DetailRow.vue?vue&type=script&lang=js&"
import style0 from "./DetailRow.vue?vue&type=style&index=0&id=1429501d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429501d",
  null
  
)

export default component.exports